import { Transition, SwitchTransition } from 'react-transition-group';
import { useState, useEffect, useRef } from 'react';
import { Header5 } from 'library/styles/text';
import { MODES as COLOR_MODES } from 'library/components/color/constants';
import Color from 'library/components/color';
import Slider from 'library/components/slider';
import Wheel from './wheel';
import Pallette from './pallette';
import {
  SelectedColorsContainer,
  Icon,
  TabsNavigation,
  Button,
} from './styles';
import { Container } from '../add-image/styles';

export const TABS = {
  COLOR: 'color',
  PICTURE: 'picture',
};

const defaultStyle = {
  transition: 'opacity 300ms ease-in-out',
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

const ColorPicker = ({
  name,
  inputRef,
  onChange,
  value,
  defaultTab = TABS.COLOR,
  images = [],
}) => {
  const [currentTab, setCurrentTab] = useState(defaultTab);
  const [selectedImage, setSelectedImage] = useState(null);
  const req = useRef(null);

  const removeColor = (color) => {
    onChange([...(value || []).filter((selected) => (color || '').replace('#', '') !== (selected || '').replace('#', ''))]);
  };

  const handleChange = (newValues = []) => {
    const uniqueValues = [...new Set(newValues)].filter((color) => !value.includes(color));

    onChange([...(value || []), ...uniqueValues]);
  };

  const clickCurrentTab = (tab) => {
    setCurrentTab(tab);
  };

  const resetSelectedValue = () => {
    setSelectedImage(null);
  };

  const handleSliderAddPallette = (id, { url }) => {
    const options = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('colormylife-token')}`,
      },
    };
    const img = new Image();

    const fileNameParts = url.split('/');
    const fileName = fileNameParts.pop();
    const isSharedImage = url.includes('/images/barcodes');
    const fileUrl = `${process.env.REACT_APP_API_URL}/images/${fileName}/${isSharedImage ? 'barcodes' : 'user'}`;

    setSelectedImage({
      id, element: img,
    });

    req.current = new Request(fileUrl, options);
  };

  useEffect(() => {
    if(images[0]?.id) {
      handleSliderAddPallette(images[0]?.id, { url: images[0].url });
    }
  }, [images[0]?.id]);

  useEffect(() => {
    if(selectedImage && selectedImage.element && req.current) {
      fetch(req.current).then((result) => result.blob()).then((response) => {
        selectedImage.element.src = URL.createObjectURL(response);
        req.current = null;
      });
    }
  }, [selectedImage]);

  return (
    <>
      {value.length
        ? (
          <SelectedColorsContainer>
            <Header5>Selected colors:</Header5>
            {value.map((color) => (
              <Color
                key={color}
                color={`${color.includes('#') ? '' : '#'}${color}`}
                mode={COLOR_MODES.DELETE}
                deleteAction={removeColor}
                large
              />
            ))}
          </SelectedColorsContainer>
        )
        : null}
      {currentTab === TABS.PICTURE && images.length
        ? (
          <Container>
            <Slider
              data={images}
              onItemClick={handleSliderAddPallette}
            />
          </Container>
        ) : null}
      <TabsNavigation>
        <Button
          isActive={currentTab === TABS.COLOR}
          onClick={() => clickCurrentTab(TABS.COLOR)}
        >
          <Icon className="icon-colors" />
          Choose from Color Wheel
        </Button>
        <Button
          isActive={currentTab === TABS.PICTURE}
          onClick={() => clickCurrentTab(TABS.PICTURE)}
        >
          <Icon className="icon-picture" />
          Choose from Photo
        </Button>
      </TabsNavigation>
      <SwitchTransition>
        <Transition
          key={currentTab}
          timeout={300}
          addEndListener={(node, done) => {
            node.addEventListener('transitionend', done, false);
          }}
        >
          {(state) => (
            <div style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
            >
              {
                currentTab === TABS.COLOR && (
                  <Wheel onChange={handleChange} value={value} />
                )
              }
              {
                currentTab === TABS.PICTURE && (
                  <Pallette onChange={handleChange} value={value} image={selectedImage} onImageReset={resetSelectedValue} />
                )
              }
            </div>
          )}
        </Transition>
      </SwitchTransition>
      <input type="hidden" ref={inputRef} name={name} />
    </>
  );
};

export default ColorPicker;
